import { GET_COUNT_FOB_FOTO_API_URL, GET_COUNT_GOUPLING_FOTO_API_URL, GET_COUNT_LINE_PDF_API_URL, GET_COUNT_NODE_FOTO_API_URL, GET_COUNT_PASSIVE_NODE_FOTO_API_URL, GET_COUNT_PON_BOX_FOTO_API_URL, GET_COUNT_WELL_FOTO_API_URL } from "../../../OpticApiConfig";

// количество файлов CABLE
export const fetchCableFileCount = async (highwayLineId) => {
  const token = localStorage.getItem('token');

  try {
    const response = await fetch(`${GET_COUNT_LINE_PDF_API_URL}?highwayLineId=${highwayLineId}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    if (response.ok) {
      const count = await response.json();
      return count; 
    } else {
      console.error("Ошибка ответа сервера:", response.statusText);
      return null; 
    }
  } catch (error) {
    console.error("Ошибка при получении количества файлов:", error);
    return null; 
  }
};

// количество файлов FOB
export const fetchFobFileCount = async (fobLocationId) => {
    const token = localStorage.getItem('token');

    try {
      const response = await fetch(`${GET_COUNT_FOB_FOTO_API_URL}?fobLocationId=${fobLocationId}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
  
      if (response.ok) {
        const count = await response.json();
        return count; 
      } else {
        console.error("Ошибка ответа сервера:", response.statusText);
        return null; 
      }
    } catch (error) {
      console.error("Ошибка при получении количества файлов:", error);
      return null; 
    }
  };

  // количество файлов FOB
export const fetchWellFileCount = async (wellId) => {
    const token = localStorage.getItem('token');

    try {
      const response = await fetch(`${GET_COUNT_WELL_FOTO_API_URL}?wellId=${wellId}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
  
      if (response.ok) {
        const count = await response.json();
        return count; 
      } else {
        console.error("Ошибка ответа сервера:", response.statusText);
        return null; 
      }
    } catch (error) {
      console.error("Ошибка при получении количества файлов:", error);
      return null; 
    }
  };

  // количество файлов COUPLING
export const fetchCouplingFileCount = async (couplingLocationId) => {
    const token = localStorage.getItem('token');

    try {
      const response = await fetch(`${GET_COUNT_GOUPLING_FOTO_API_URL}?couplingLocationId=${couplingLocationId}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
  
      if (response.ok) {
        const count = await response.json();
        return count; 
      } else {
        console.error("Ошибка ответа сервера:", response.statusText);
        return null; 
      }
    } catch (error) {
      console.error("Ошибка при получении количества файлов:", error);
      return null; 
    }
  };

  // количество файлов PonBox
export const fetchPonBoxFileCount = async (ponBoxLocationId) => {
    const token = localStorage.getItem('token');

    try {
      const response = await fetch(`${GET_COUNT_PON_BOX_FOTO_API_URL}?ponBoxLocationId=${ponBoxLocationId}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
  
      if (response.ok) {
        const count = await response.json();
        return count; 
      } else {
        console.error("Ошибка ответа сервера:", response.statusText);
        return null; 
      }
    } catch (error) {
      console.error("Ошибка при получении количества файлов:", error);
      return null; 
    }
  };

    // количество фото NODE
export const fetchNodeFileCount = async (hid, entrance) => {
  const token = localStorage.getItem('token');

  try {
    const response = await fetch(`${GET_COUNT_NODE_FOTO_API_URL}?hid=${hid}&entrance=${entrance}`, {
      headers: {
          'Authorization': `Bearer ${token}`
      }
  });

    if (response.ok) {
      const count = await response.json();
      return count; 
    } else {
      console.error("Ошибка ответа сервера:", response.statusText);
      return null; 
    }
  } catch (error) {
    console.error("Ошибка при получении количества файлов:", error);
    return null; 
  }
};

// количество фото PassiveNODE
export const fetchPassiveNodeFileCount = async (nodeId) => {
  const token = localStorage.getItem('token');

  try {
    const response = await fetch(`${GET_COUNT_PASSIVE_NODE_FOTO_API_URL}?nodeId=${nodeId}`, {
      headers: {
          'Authorization': `Bearer ${token}`
      }
  });

    if (response.ok) {
      const count = await response.json();
      return count; 
    } else {
      console.error("Ошибка ответа сервера:", response.statusText);
      return null; 
    }
  } catch (error) {
    console.error("Ошибка при получении количества файлов:", error);
    return null; 
  }
};